import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelDescription,
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';
import { MatToolbar } from '@angular/material/toolbar';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { NotificationEmptyComponent } from '@next/core-lib/components';
import { TranslatePipe, AgrDatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Barn, Cycle } from 'src/app/cycle/models/cycle.model';
import { Concept } from 'src/app/cycle/models/flock-registration-service.model';
import { getCycles } from 'src/app/cycle/store/selectors/cycle.selectors';

import * as reportActions from '../../store/actions/report.actions';
import { ReportNavigationComponent } from '../report-navigation/report-navigation.component';

import { ReportPrintComponent } from '../report-print/report-print.component';

@Component({
  selector: 'app-report-overview-report',
  templateUrl: 'report-overview.component.html',
  styleUrls: ['report-overview.component.scss'],
  imports: [
    MatToolbar,
    ReportNavigationComponent,
    NgIf,
    MatNavList,
    MatAccordion,
    NgFor,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatButton,
    MatIcon,
    MatDivider,
    NotificationEmptyComponent,
    ReportPrintComponent,
    AsyncPipe,
    TranslatePipe,
    AgrDatePipe,
  ],
})
export class ReportOverviewComponent {
  private readonly store = inject<Store<RootState>>(Store);

  cycles$: Observable<Cycle[]> = this.store
    .select(getCycles)
    .pipe(map((cycles) => cycles.sort((a, b) => (a.cycleNumber < b.cycleNumber ? 1 : -1))));

  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  printBarnPdf(barnId: number, cycleId: number, concept: Concept): void {
    this.store.dispatch(
      reportActions.loadReport({
        cycleId,
        conceptId: concept.id,
        barnId,
      }),
    );
  }

  getBarnsByCycle(cycle: Cycle) {
    const barns: Barn[] = [];
    cycle.dayOldChicks.forEach((d) => {
      if (barns.findIndex((b) => b.id === d.barn.id) < 0) {
        barns.push(d.barn);
      }
    });
    return barns.sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  printCyclePdf(event: MouseEvent, cycleId: number, concept: Concept): void {
    this.store.dispatch(
      reportActions.loadReport({
        cycleId,
        conceptId: concept.id,
      }),
    );
    event.stopPropagation();
    event.preventDefault();
  }
}
